import { values } from '../_helpers'

const _enum = {
  low: 0,
  medium: 1,
  high: 2,
}

const alcohol = { ..._enum, name: 'alcohol', values: values(_enum) }

export {
  alcohol
}
